var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 15H15.625V12.5H14.375V15H11.875V16.25H14.375V18.75H15.625V16.25H18.125V15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 3.125H12.5V2.5C12.499 2.16877 12.367 1.85139 12.1328 1.61717C11.8986 1.38296 11.5812 1.25096 11.25 1.25H6.25C5.91877 1.25096 5.60139 1.38296 5.36717 1.61717C5.13296 1.85139 5.00096 2.16877 5 2.5V3.125H3.125C2.79377 3.12596 2.47639 3.25796 2.24217 3.49217C2.00796 3.72639 1.87596 4.04377 1.875 4.375V17.5C1.87596 17.8312 2.00796 18.1486 2.24217 18.3828C2.47639 18.617 2.79377 18.749 3.125 18.75H9.375V17.5H3.125V4.375H5V6.25H12.5V4.375H14.375V10H15.625V4.375C15.624 4.04377 15.492 3.72639 15.2578 3.49217C15.0236 3.25796 14.7062 3.12596 14.375 3.125ZM11.25 5H6.25V2.5H11.25V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentPlus);
export default __webpack_public_path__ + "static/media/ic-document-plus.8ed2f809e013211b0695c65585dace77.svg";
export { ForwardRef as ReactComponent };